import { createReducer } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import { toggleDrawer, toggleDrawerContent, logout } from '../actions/ui';
import { codeBenchActions } from '@codametrix/ui-common';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
export const reducer = createReducer(InitialState.coderNotes, (builder)=>{
    builder.addCase(logout.type, ()=>({
            ...InitialState.coderNotes
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.coderNotes
        }));
    builder.addCase(toggleDrawerContent.type, (state, action)=>{
        return {
            ...state,
            isOpen: action.payload
        };
    });
    builder.addCase(toggleDrawer.type, (state, action)=>{
        let updatedState = {
            ...state,
            isDrawerOpen: action.payload
        };
        if (!action.payload) updatedState = {
            ...InitialState.coderNotes,
            activeUser: state.activeUser,
            isDrawerOpen: action.payload
        };
        return updatedState;
    });
    builder.addCase(UIActions.setActiveUser.type, (state, action)=>{
        return {
            ...state,
            activeUser: action.payload
        };
    });
    builder.addCase(codeBenchActions.navigateCoderNotes.pending, (state, action)=>{
        return {
            ...state,
            isDrawerOpen: true,
            servicesLoading: true,
            coderNotesParams: action.meta.arg
        };
    });
    builder.addCase(codeBenchActions.navigateCoderNotes.fulfilled, (state)=>{
        return {
            ...state,
            isOpen: true,
            servicesLoading: false
        };
    });
    builder.addCase(codeBenchActions.fetchCoderNotes.fulfilled, (state, action)=>{
        return {
            ...state,
            coderNotesList: action.payload
        };
    });
    builder.addCase(codeBenchActions.addCoderNote.pending, (state, action)=>{
        return {
            ...state,
            coderNote: action.meta.arg.noteContent ?? ''
        };
    });
    builder.addCase(codeBenchActions.addCoderNote.fulfilled, (state)=>{
        return {
            ...state,
            coderNote: ''
        };
    });
});
export default reducer;
